module.exports = __webpack_public_path__ + "static/media/fire-extinguisher.e26c8186.svg";